import { useContext, useEffect, useRef, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import Swal from 'sweetalert2'
import { sendEmailSecret } from '../../API/EmailSecret/sendEmail'
import { signin, signupEmployee } from '../../API/Login/login'
import { CompanyContext } from '../../Store/CompanyContext'
import { generateHash } from './generateHash'
import ResponseModal from './responseModal'
import './signupB2E.sass'

const SignupB2E = () => {
	const history = useHistory()
	const { actions } = useContext(CompanyContext)
	const { email } = useParams()
	const [show, setShow] = useState(false)
	const [password, setPassword] = useState('')
	const [repeatPassword, setRepeatPassword] = useState('')
	const [secret, setSecret] = useState('')

	const handleChangePassword = event => {
		setPassword(event.currentTarget.value)
	}

	const handleChangeRepeatPassword = event => {
		setRepeatPassword(event.currentTarget.value)
	}

	const handleChangeSecret = event => {
		setSecret(event.currentTarget.value)
	}

	const checkSecret = async () => {
		const code = await generateHash(email)
		return secret === code
	}

	const mountedRef = useRef(false)

	useEffect(() => {
		if (!mountedRef.current) {
			const sendEmail = async () => {
				try {
					const res = await sendEmailSecret({ email })
					if (res.status === 200) {
						Swal.fire({
							title: 'Para tu seguridad, se envió un código al correo electrónico informado.',
							text: 'Ingrese el código a continuación para confirmar la creación o cambio de contraseña.',
							icon: 'info',
						})
					}
				} catch (error) {
					console.error(error)
				}
			}

			sendEmail()
			mountedRef.current = true
		}
	}, []) // Empty dependency array

	const handleLogin = async () => {
		const account = {
			email,
			password,
			repeatPassword,
		}
		if (password !== repeatPassword) {
			Swal.fire({
				title: 'Las contraseñas ingresadas no coinciden.',
				text: 'Por favor, compruébalo e inténtalo de nuevo',
				icon: 'error',
			})
			return
		}

		const validSecret = await checkSecret()

		if (!validSecret) {
			Swal.fire({
				title: 'El código no es válido.',
				text: 'Por favor verifique el código recibido por email e inténtelo nuevamente.',
				icon: 'error',
			})
			return
		}
		const response = await signupEmployee(account)

		if (response.status === 200) {
			const login = await signin(account)
			localStorage.setItem('token', login.token)
			localStorage.setItem('user', JSON.stringify(login.response))
			if (login.response.roleId == 1) localStorage.setItem('email', JSON.stringify(email))

			const bringElementsForToken = email + ':' + password
			const utf8Bytes = decodeURIComponent(encodeURIComponent(bringElementsForToken))
			const hash = window.btoa(utf8Bytes)
			localStorage.setItem('hash', hash)

			actions.setLogin(login.response)
			const data = await response.json()
			const route = Number(data.roleId) === 2 ? '/employee' : '/app'

			history.push(route)
		}
		setShow(true)
	}

	return (
		<>
			<ResponseModal setShow={setShow} show={show} />
			<div className='signupB2E'>
				<img
					className='companyLogo'
					src='https://aadcdn.msftauthimages.net/dbd5a2dd-q-vgx0wbu9ntyuhzdvuv5jk-4tjk439hs8ffouhilva/logintenantbranding/0/bannerlogo?ts=637565229533956374'
					alt='Logotipo de la empresa'
				></img>
				<h2>Crea tu contraseña</h2>
				{email && (
					<div className='collaborator'>
						<h4>
							<span> {email} </span>
							bienvenido
						</h4>
					</div>
				)}
				<div className='group-input'>
					<label htmlFor='password'></label>
					<input placeholder='Contraseña' type='password' name='password' value={password} onChange={handleChangePassword} />
				</div>
				<div className='group-input my-2'>
					<label htmlFor='repeatPassword'></label>
					<input
						placeholder='Repite tu Contraseña'
						type='password'
						name='repeatPassword'
						value={repeatPassword}
						onChange={handleChangeRepeatPassword}
					/>
				</div>
				<div className='group-input mt-2'>
					<label htmlFor='secret'></label>
					<input placeholder='Código' type='secret' name='secret' value={secret} onChange={handleChangeSecret} />
				</div>
				<div className='content-button'>
					<button onClick={handleLogin}>Crear</button>
				</div>
			</div>
		</>
	)
}
export default SignupB2E

export const SignupB2ENoSecret = () => {
	const history = useHistory()
	const { actions } = useContext(CompanyContext)
	const { email } = useParams()
	const [show, setShow] = useState(false)
	const [password, setPassword] = useState()

	const handleChangePassword = event => {
		setPassword(event.currentTarget.value)
	}

	const handleLogin = async () => {
		const account = {
			email,
			password,
		}
		const response = await signupEmployee(account)

		if (response.status === 200) {
			const login = await signin(account)
			localStorage.setItem('token', login.token)
			localStorage.setItem('user', JSON.stringify(login.response))
			if (login.response.roleId == 1) localStorage.setItem('email', JSON.stringify(email))

			const bringElementsForToken = email + ':' + password
			const utf8Bytes = decodeURIComponent(encodeURIComponent(bringElementsForToken))
			const hash = window.btoa(utf8Bytes)
			localStorage.setItem('hash', hash)

			actions.setLogin(login.response)
			const data = await response.json()
			const route = Number(data.roleId) === 2 ? '/employee' : '/app'

			history.push(route)
		}
		setShow(true)
	}

	return (
		<>
			<ResponseModal setShow={setShow} show={show} />
			<div className='signupB2E'>
				<img
					className='companyLogo'
					src='https://aadcdn.msftauthimages.net/dbd5a2dd-q-vgx0wbu9ntyuhzdvuv5jk-4tjk439hs8ffouhilva/logintenantbranding/0/bannerlogo?ts=637565229533956374'
					alt='Logotipo de la empresa'
				></img>
				<h2>Crea tu contraseña</h2>
				{email && (
					<div className='collaborator'>
						<h4>
							<span> {email} </span>
							bienvenido
						</h4>
					</div>
				)}
				<div className='group-input'>
					<label htmlFor='password'></label>
					<input placeholder='Contraseña' type='password' name='password' value={password} onChange={handleChangePassword} />
				</div>
				<div className='content-button'>
					<button onClick={handleLogin}>Crear</button>
				</div>
			</div>
		</>
	)
}
